export var convertFieldToString = function convertFieldToString(value) {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return value.toString();
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'undefined') return 'undefined';
  if (value === null) return 'null';
  return JSON.stringify(value);
};